import { render, staticRenderFns } from "./EditSellerExclusionDialogContent.vue?vue&type=template&id=784845b0&scoped=true&"
import script from "./EditSellerExclusionDialogContent.vue?vue&type=script&lang=js&"
export * from "./EditSellerExclusionDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerExclusionDialogContent.vue?vue&type=style&index=0&id=784845b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784845b0",
  null
  
)

export default component.exports